export default "__VITE_ASSET__ivRkk3Cc__"